import React from "react";
import { Modal, Image } from "react-bootstrap";

const CustomKycModal = ({
  show,
  onHide,
  icon,
  iconClass,
  heading,
  headingClass,
  text,
  children,
  buttons = [],
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="deliva-popup"
    >
      <Modal.Body>
        <div className="modal-content-wrap text-center">

          {icon && (
            <Image
              src={icon}
              className={iconClass || "img-fluid user-block-img"}
            />
          )}

          {heading && (
            <h4 className={headingClass || "mt-3"}>{heading}</h4>
          )}

          {text && <p className="color-grey">{text}</p>}

          {children}

          <div className="text-center">
            {buttons.map((btn, i) => (
              <button
                key={i}
                className={btn.className}
                onClick={btn.onClick}
                disabled={btn.disabled||false}
              >
                {btn.label}
              </button>
            ))}
          </div>

        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CustomKycModal;
